module.exports = __webpack_public_path__ + "static/media/supporter-success.57fab4a9.png";